export const nameRegEx: [RegExp, { message: string }] = [
  /^[\w\u00C0-\u024F0-9,.&\-:#\s\/()]*$/u,
  {
    message:
      "Only letters, numbers, spaces and the following punctuation marks are allowed: ,.&-:#/()",
  },
];
